//DEPRECATED INSTEAD USE ELLIPSESTEXT INSTEAD

import React, { PropTypes } from 'react';

import styled from 'styled-components';

const Content = styled.span`
  max-width: ${props => props.maxWidth + 'px'};
  overflow:hidden;
  display:inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const TextEllipsis = ({ data, maxWidth }) => {
	return (
		<Content maxWidth={maxWidth}>
			{data}
		</Content>
	);
};

TextEllipsis.propTypes = {
	content: PropTypes.string,
	maxWidth: PropTypes.number
};

TextEllipsis.defaultProps = {
	maxWidth: '150'
};
export default TextEllipsis;



// WEBPACK FOOTER //
// ./src/components/utils/TableUtils/TextEllipsis.js